const o = new URL("../../assets/icon-community-doodi-mevx-D8oUuO8q.png", import.meta.url).href;
export {
  o as default
};
//# sourceMappingURL=icon-community-doodi-mevx.png.js.map
